// eslint-disable-next-line no-unused-vars

import React, { useEffect, useState } from 'react';
import './fonts/Fonts.css';
import './css/index.css';
import './css/adaptation.css';
import WorkspaceRouter from './setup/Router';
import { Global, css } from '@emotion/react';
import { createTheme } from '@mui/material';
import ThemeTypes from 'common/types/ThemeTypes';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import AuthProvider from 'common/context/AuthContext';
import darkThemeData from 'common/data/darkThemeData';
import lightThemeData from 'common/data/lightThemeData';
import ClockIcon from 'common/icons/clock.svg';
import CalendarIcon from 'common/icons/calendar.svg';
import ClockLightIcon from 'common/icons/clock-light.svg';
import CalendarLightIcon from 'common/icons/calendar-light.svg';



const theme: ThemeTypes = createTheme(lightThemeData);
const darkTheme: ThemeTypes = createTheme(darkThemeData);


function App() {
  const [isLightTheme, setThemePicked] = useState(JSON.parse(localStorage.getItem('isLightTheme') || 'true'));
  // update localStorage on theme change
  useEffect(() => {
    localStorage.setItem('isLightTheme', JSON.stringify(isLightTheme));
  }, [isLightTheme]);
  const globalStyles = css`
    body {
      transition: color .3s ease-out, background-color .3s ease-out, background .3s ease-out;
    }
    /*body * {
      transition: unset!important;
    }*/
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: Mulish;
    }
    span, p, h1, h2, h3, h4, h5, h6, a, button, input, label, div, li, ul, ol, textarea {
      
    }
    .error-text {
      color: ${theme.colors.error};
    }
    body {
      background-color: ${isLightTheme ? theme.colors.backgroundColor : darkThemeData.colors.backgroundColor};
      color: ${isLightTheme ? theme.colors.primaryTextColor : darkThemeData.colors.primaryTextColor};
    }
    .basic-link {
      color: ${isLightTheme ? theme.colors.primaryColor : darkThemeData.colors.primaryColor};
      cursor: pointer; 
      &:hover {
        text-decoration: underline;
      }
    }
    .gray-text {
      color: ${isLightTheme ? theme.colors.gray : darkThemeData.colors.gray};
    }
    .svg-black {
      stroke: ${isLightTheme ? theme.colors.black : darkThemeData.colors.black};
    }

    .svg-fill {
      stroke: unset;
      fill: ${isLightTheme ? theme.colors.black : darkThemeData.colors.black};
    }
    .svg-none {
      stroke: inherit;
      fill: inherit;
    }
    .svg-primary-stroke {
      stroke: ${isLightTheme ? theme.colors.primaryColor : darkThemeData.colors.primaryColor};
    }
    .svg-primary-fill {
      fill: ${isLightTheme ? theme.colors.primaryColor : darkThemeData.colors.primaryColor};
    }
    .svg-button {
      cursor: pointer;
      transition: stroke .3s ease-out;
    }
    .svg-fill.svg-button {
      cursor: pointer;
      transition: fill .3s ease-out;
    }
    .svg-button:hover, .svg-button.active {
      stroke: ${isLightTheme ? theme.colors.primaryColor : darkThemeData.colors.primaryColor};
    }
    .svg-fill.svg-button:hover, .svg-fill.svg-button.active {
      stroke: unset;
      fill: ${isLightTheme ? theme.colors.primaryColor : darkThemeData.colors.primaryColor};
    }
    .MuiSwitch-root:not('.Mui-checked') .MuiSwitch-track  {
      background-color: ${isLightTheme ? theme.colors.gray : darkThemeData.colors.gray};
    }
    input[type="date"]::-webkit-calendar-picker-indicator {
      background: url(${isLightTheme ? CalendarIcon : CalendarLightIcon}) no-repeat;
      min-width: 20px;
      min-height: 20px;
      background-position: center;
      cursor:pointer;
    }
    input[type="time"]::-webkit-calendar-picker-indicator {
      background: url(${isLightTheme ? ClockIcon : ClockLightIcon}) no-repeat;
      min-width: 20px;
      min-height: 20px;
      height: 20px;
      width: 20px;
      background-size: 70%;
      background-position: center;
      cursor:pointer;
    }
    .error-text {
      color: ${theme.colors.error};
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
        transition: background-color 9999s ease-in-out 0s;
    }
  `;
  return (
    <>
      <ThemeProvider theme={isLightTheme ? theme : darkTheme}>
        <AuthProvider>
          <Global
            styles={globalStyles}
          />

          <WorkspaceRouter isLightTheme={isLightTheme} setThemePicked={setThemePicked} />
        </AuthProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
